import React from "react";

export const LoadRule : React.FC = React.memo(() => (
    <div className="min-h-screen flex items-center justify-center px-4">
        <div className="relative rounded-3xl backdrop-blur shadow-2xl ring-1 ring-orange-200/30 px-10 py-8 w-full max-w-md text-center">
            <div className="flex flex-col items-center space-y-4 z-10 relative">
                <span className="text-5xl animate-spin">🪐</span>
                <h2 className="text-xl font-semibold text-orange-400 drop-shadow-sm">
                    Analyzing the stars...
                </h2>
                <p className="text-lg text-orange-300">
                    Your rule is being summoned from the cosmos
                </p>
            </div>
        </div>
    </div>

));
